import {Close, Copy} from '@carbon/icons-react';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import * as Preact from 'preact';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import {LinearProgress} from "@mui/material";

export interface Props {
    open: boolean;
    link: string | undefined;
    onCopyClick: (link: string) => void;
    onCloseClick: () => void;
    onCloseAppClick: () => void;
}

export const Component = (p: Props) => {
    return (
        <Dialog
            open={p.open}
            BackdropProps={{
                style: {
                    borderRadius: { xs: 0, md: '24px' },
                    right: 0,
                    backgroundColor: 'rgba(34, 33, 76, 0.2)',
                },
            }}
            sx={{
                width: { xs: '100%', md: 'calc(100% - 72px)' },
                '& .MuiBackdrop-root': {
                    width: { xs: '100%', md: 'calc(100% - 72px)' },
                },
            }}
            PaperProps={{
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    width: { xs: '295px', md: '325px' },
                    borderRadius: '8px',
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '7px',
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <IconButton size="small" color="secondary" onClick={p.onCloseClick}>
                    <Close size={24} />
                </IconButton>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingX: '36px',
                    paddingBottom: '24px',
                    gap: '36px',
                }}
            >
                <Typography
                    sx={{
                        fontSize: '24px',
                        fontWeight: 600,
                        textAlign: 'center',
                        lineHeight: '27px',
                    }}
                >
                    Copy the link to return to your sofa.
                </Typography>
                { p.link !== undefined ? (<TextField
                    type="text"
                    value={p.link}
                    variant="standard"
                    onClick={() => {
                        p.onCopyClick(p.link!);
                    }}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton size="small">
                                    <Copy />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />) : (<LinearProgress sx={{width: '100%'}}/>)
                }
                <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={p.onCloseAppClick}
                >
                    Close configurator
                </Button>
            </Box>
        </Dialog>
    );
};

Component.displayName = 'CloseModal';
